interface LiveEditState {
  inEditMode: boolean;
  isEditable: boolean;
}

interface LiveEditResult {
  liveEditState: {
    value: LiveEditState;
  };
  inEditModeAndEditable: ComputedRef<boolean>;
}

export const useLiveEdit = (initialValue?: boolean): LiveEditResult => {
  const liveEditState = useState<LiveEditState>('live-edit-state', () => ({
    inEditMode: initialValue || false,
    isEditable: initialValue || false,
  }));

  const inEditModeAndEditable = computed((): boolean => {
    return liveEditState.value.inEditMode && liveEditState.value.isEditable;
  });

  return { liveEditState, inEditModeAndEditable };
};
